import { Center, Skeleton } from '@chakra-ui/react';
import CustomDataTableDetailBtn from '@Modules/core/components/table/CustomDataTableDetailBtn';
import GenericDataTableBtn from '@Modules/core/components/table/GenericDataTableBtn';
import { createColumnHelper } from '@tanstack/react-table';

export type TBatchesMaintenanceDataTableData = {
  primaryKey: string | number,
  jobId: string,
  user: string,
  cass: string,
  totalDuration: string,
  batch: string,
  failure: string,
  to: string,
};
 

type Props = {
  isLoading: boolean | undefined,
  handleDataTableBtn: (row: any) => void,
};

const columnHelper = createColumnHelper<TBatchesMaintenanceDataTableData>();

export function getBatchesMaintenanceDataTableColumns({ isLoading, handleDataTableBtn }: Props) {
  return [
    columnHelper.accessor('jobId', {
      id: 'jobId',
      header: 'ID Job',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('user', {
      id: 'user',
      header: 'Utilisateur',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('cass', {
      id: 'cass',
      header: 'Cass.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('totalDuration', {
      id: 'totalDuration',
      header: 'Tot. Durée',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('batch', {
      id: 'batch',
      header: 'Batch',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('failure', {
      id: 'failure',
      header: 'Echec',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('to', {
      id: 'to',
      header: 'T.O',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              
              <GenericDataTableBtn label='Stop' onClick={() => handleDataTableBtn(props.row)} />
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}